import { render, staticRenderFns } from "./ExamListpage.vue?vue&type=template&id=be5f43dc"
import script from "./ExamListpage.vue?vue&type=script&lang=js"
export * from "./ExamListpage.vue?vue&type=script&lang=js"
import style0 from "./ExamListpage.vue?vue&type=style&index=0&id=be5f43dc&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports